export default __webpack_public_path__ + "static/media/Owsap.ff0681eb.svg";